import { Trustpilot } from "@airhelp/react";
import { useTrustpilotInfo } from "contexts/DataContext";
import { useTranslations, useLocalizedData } from "contexts/LocalizationContext";
import type { sbEditableProps } from "types/storyblok";

const TrustpilotAdapter = ({ sbEditable }: { sbEditable?: sbEditableProps }) => {
  const { numberOfReviews: { total } = { total: 0 }, score: { trustScore } = { trustScore: 0 } } = useTrustpilotInfo();
  const translations = useTranslations();
  const { getLocalizedNumber } = useLocalizedData();

  const translationVariables = {
    "%score%": `${getLocalizedNumber(trustScore)}/5`,
    "%number-of-reviews%": getLocalizedNumber(total),
  };
  const trustpilotText = translations("trustpilot", translationVariables);
  return <Trustpilot text={trustpilotText} {...sbEditable} />;
};

export default TrustpilotAdapter;
